import {Injectable} from '@angular/core';
import {InsoleElementDefinitionSummaryModel} from "./insoleElementDefinitionSummary.model";
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {PermissionsConverter} from "../../../../../common/converter/permissions.converter";

@Injectable({
    providedIn: 'root'
})
export class InsoleElementDefinitionSummaryConverter extends HttpModelConverter<InsoleElementDefinitionSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): InsoleElementDefinitionSummaryModel {
        return new InsoleElementDefinitionSummaryModel();
    }

    protected enrichObject(result: InsoleElementDefinitionSummaryModel, src: InsoleElementDefinitionSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
    }
}
